<template>
    <button
        type="button"
        class="brand-support-overview__chip"
        :class="stateClasses"
        :aria-current="company.isCurrent ? 'true' : null"
        :aria-disabled="company.canOpen ? null : 'true'"
        :aria-label="ariaLabel"
        @click="$emit('open', company)"
        @mouseenter="$emit('show-tip', $el)"
        @mouseleave="$emit('hide-tip')"
        @focus="$emit('show-tip', $el)"
        @blur="$emit('hide-tip')"
    >
        <span class="brand-support-overview__letter" aria-hidden="true">{{ company.letter }}</span>
        <span class="brand-support-overview__count" aria-hidden="true">
            <span v-if="busy" class="brand-support-overview__spin"></span>
            <template v-else>{{ countLabel }}</template>
        </span>
        <span
            v-if="company.warning"
            class="brand-support-overview__mark brand-support-overview__mark_warn"
        ></span>
        <span
            v-else-if="stale"
            class="brand-support-overview__mark brand-support-overview__mark_stale"
        ></span>
        <span v-if="!company.canOpen" class="brand-support-overview__lock">
            <svg aria-hidden="true" width="8" height="8"><use href="#icon-lock"></use></svg>
        </span>
    </button>
</template>

<script>
import { waitingText } from './format'

export default {
    name: 'CompanyShortcut',
    props: {
        company: {
            type: Object,
            required: true,
        },
        stale: {
            type: Boolean,
            default: false,
        },
        busy: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        countLabel() {
            return this.company.waiting === null ? '—' : this.company.waiting
        },
        stateClasses() {
            return {
                'is-current': this.company.isCurrent,
                'is-pos': this.company.waiting > 0 && !this.stale,
                'is-stale': this.stale,
                'is-unavail': this.company.unavailable,
                'is-locked': !this.company.canOpen,
                'is-busy': this.busy,
            }
        },
        ariaLabel() {
            let label = `${this.company.name} — ${waitingText(this.company)}.`
            if (this.company.warning) label += ' Число может быть неточным.'
            if (this.stale) label += ' Данные устарели.'
            if (!this.company.canOpen) return `${label} Нет доступа к чатам.`
            if (this.company.isCurrent) return `${label} Текущая компания. Открыть общую очередь.`
            return `${label} Перейти в компанию и открыть чаты.`
        },
    },
}
</script>
